import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlantService } from './plant/plant.service';
import { PlantRepositoryService } from './plant/plant-repository.service';
import { DeviceService } from './device/device.service';
import { DeviceRepositoryService } from './device/device-repository.service';
import { UserService } from './user/user.service';
import { CountryRepositoryService } from './country/country-repository.service';
import { SearchCatalogService } from './catalog/search-catalog.service';
import { SerialNumberService } from './serial-number/serial-number.service';
import { SerialNumberRepositoryService } from './serial-number/serial-number-repository.service';
import { UserRepositoryService } from './user/user-repository.service';
import { ProcedureRepositoryService } from './procedure/procedure-repository.service';
import { ProcedureService } from './procedure/procedure.service';
import { StepService } from './procedure/step.service';
import { ArticleCodesRepositoryService } from './article-code/article-codes-repository.service';
import { LanguageRepositoryService } from './language/language-repository.service';
import { ObjRepositoryService } from './procedure/obj-repository.service';
import { ArticleCodeService } from './article-code/article-code.service';
import { MaintenanceService } from './maintenance/maintenance.service';
import { MaintenanceRepositoryService } from './maintenance/maintenance-repository.service';
import { MaintenanceCheckService } from './maintenance/maintenance-check.service';
import { NewsService } from './news/news.service';
import { NewsRepositoryService } from './news/news-repository.service';
import { EventAcademyService } from './event/event-academy.service';
import { EventAcademyRepositoryService } from './event/event-academy-repository.service';
import { DeviceDocumentationRepositoryService } from './device-documentation/device-documentation-repository.service';
import { AgendaRepositoryService } from './agenda/agenda-repository.service';
import { MaintenanceReminderService } from './maintenance/maintenance-reminder.service';
import { DeviceHistoryService } from './device/device-history.service';
import { DeviceHistoryRepositoryService } from './device/device-history-repository.service';
import { ProductFamilyService } from './product-families/product-family.service';
import { ProductFamilyRepositoryService } from './product-families/product-family-repository.service';
import { DeviceTypeService } from './device-type/device-type.service';
import { DeviceTypeRepositoryService } from './device-type/device-type-repository.service';

@NgModule({
  providers: [PlantService,
    PlantRepositoryService,
    DeviceService,
    DeviceRepositoryService,
    UserService,
    CountryRepositoryService,
    SearchCatalogService,
    SerialNumberService,
    SerialNumberRepositoryService,
    UserRepositoryService,
    ProcedureRepositoryService,
    ProcedureService,
    StepService,
    ArticleCodeService,
    ArticleCodesRepositoryService,
    LanguageRepositoryService,
    ObjRepositoryService,
    MaintenanceService,
    MaintenanceRepositoryService,
    MaintenanceCheckService,
    NewsService,
    NewsRepositoryService,
    EventAcademyService,
    EventAcademyRepositoryService,
    DeviceDocumentationRepositoryService,
    AgendaRepositoryService,
    MaintenanceReminderService,
    DeviceHistoryService,
    DeviceHistoryRepositoryService,
    ProductFamilyService,
    ProductFamilyRepositoryService,
    DeviceTypeService,
    DeviceTypeRepositoryService],
  imports: [
    CommonModule
  ]
})
export class ModelsModule { }
